import React, { Fragment } from 'react'
import { Button, Input, Col, Row } from 'reactstrap';
import Select from 'react-select';
import { Dialog } from 'primereact/dialog';
import './styleM.css';


export const ModalSpecialDiscount = (props) => {

    const {

        // ? DIALOG
        modal,
        toggle,

        // ? INPUTS
        special_discount_code,
        handleInputChangeSpecialDiscount,
        percentage,
        validPorcentejeSpecial,
        dataPreloaded,
        handleSelectValuesPreloadedDiscounts,
        id_preloaded_discount,

        // ? CONFIGURATION DISCOUNTS
        isPreloadedApplied,
        setIsPreloadedApplied,
        isCodeApplied,
        setIsCodeApplied,
        isPercentageApplied,
        setIsPercentageApplied,
        handleApplyPreloaded,
        handleApplyCode,
        handleApplyPercentage,
        isAnyApplied,

        // ? LABCEN
        viewLabcen,
        percentageDiscount,
        handleInputChangeWorkOrder,

        // ? SELF - APPLIED 
        listCampaigns,
        selectedCampaign,
        handleChangeCampaign,

        // ? INSAN
        validatePriceWorkOrder,
        new_price,
        id_branch


    } = props;




    return (

        <Dialog
            visible={modal}
            onHide={toggle}
            modal
            maskClassName="custom-total-mask"
            draggable={false}
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-tag"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {viewLabcen ? "Descuento" : "Descuentos especiales"}
                            </div>


                        </div>

                    </div>
                </div>
            }
            className={`Global-dialog Global-dialog Global-blue Global-xs-v `}
            footer={
                viewLabcen ? (
                    <>
                        <Button
                            color="secondary"
                            type="button"
                            onClick={toggle}
                        >
                            Aplicar
                        </Button>
                    </>
                ) : null
            }
        >
            {
                viewLabcen && (
                    <Col sm="12" className="pt-3">
                        <Row className="align-items-center">

                            <Col sm="9" className='pt-2' >
                                <div className="discount-alert-labcen">
                                    <i className="fa fa-info-circle"></i>
                                    Seleccione el porcentaje que desea utilizar
                                </div>
                            </Col>

                            <Col sm="3">
                                <input
                                    className="discount-input-line"
                                    name="percentageDiscount"
                                    type="number"
                                    onChange={handleInputChangeWorkOrder}
                                    value={percentageDiscount}
                                    placeholder="%"
                                />
                            </Col>

                        </Row>
                    </Col>
                )
            }
            {
                !viewLabcen && <Col sm="12" className='p-l-0 p-r-0 pt-3' >
                    {
                        // ? SELF - APPLIED
                    }

                    {
                        listCampaigns.length > 0 && <div className='pb-3' >
                            <div className="discount-alert">
                                <i className="fa fa-info-circle"></i>
                                Campañas adecuadas para el paciente
                            </div>

                            <div className="discount-container">
                                <Select
                                    classNamePrefix="select"
                                    name="selectedCampaign"
                                    value={selectedCampaign}
                                    placeholder="Selecciona una campaña"
                                    options={listCampaigns}
                                    onChange={(e) => handleChangeCampaign(e)}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        control: (provided, state) => ({
                                            ...provided,
                                            borderRadius: "14px",
                                            minHeight: "36px",
                                            fontSize: "10px",
                                            background: state.isFocused ? "#eff6ff" : "#fff",
                                            borderColor: state.isFocused ? "#1e3a8a" : "#d1d5db",
                                            boxShadow: state.isFocused
                                                ? "0 0 0 2px rgba(30,58,138,0.25)"
                                                : "none",
                                            transition: "all .2s ease",
                                            paddingLeft: "4px"
                                        }),

                                        valueContainer: (provided) => ({
                                            ...provided,
                                            padding: "2px 8px"
                                        }),

                                        input: (provided) => ({
                                            ...provided,
                                            margin: "0px",
                                            padding: "0px"
                                        }),

                                        indicatorSeparator: () => ({
                                            display: "none"
                                        }),

                                        dropdownIndicator: (provided, state) => ({
                                            ...provided,
                                            padding: "4px",
                                            color: state.isFocused ? "#1e3a8a" : "#64748b"
                                        }),

                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: "12px",
                                            overflow: "hidden",
                                            marginTop: "6px"
                                        }),

                                        menuList: (provided) => ({
                                            ...provided,
                                            padding: "4px"
                                        }),

                                        option: (provided, state) => ({
                                            ...provided,
                                            fontSize: "12px",
                                            padding: "8px 10px",
                                            borderRadius: "8px",
                                            backgroundColor: state.isSelected
                                                ? "#1e3a8a"
                                                : state.isFocused
                                                    ? "#eff6ff"
                                                    : "#fff",
                                            color: state.isSelected ? "#fff" : "#1e293b",
                                            cursor: "pointer"
                                        }),

                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                                    }}
                                />

                            </div>

                        </div>
                    }


                    <div className="discount-alert">
                        <i className="fa fa-info-circle"></i>
                        Seleccione el descuento que desea utilizar
                    </div>
                    <div className="discount-container">

                        {/* CODE DISCOUNT*/}
                        <div className={`discount-card ${isCodeApplied ? "active" : ""}`}>
                            <label>Código generado</label>

                            <div className="discount-row">
                                <Input
                                    name="special_discount_code"
                                    value={isCodeApplied ? `Código utilizado`
                                        : special_discount_code}

                                    onChange={(e) => {
                                        handleInputChangeSpecialDiscount(e);
                                        setIsCodeApplied(false);
                                    }}
                                    className={`discount-input ${special_discount_code ? "has-value" : ""}`}
                                    disabled={isAnyApplied && !isCodeApplied}

                                />

                                <Button
                                    size="sm"
                                    className={`btn-warning ${isCodeApplied ? "applied" : ""}`}
                                    onClick={handleApplyCode}
                                    disabled={isCodeApplied || (isAnyApplied && !isCodeApplied)}
                                >
                                    {isCodeApplied ? "Aplicado" : "Aplicar"}
                                </Button>
                            </div>
                        </div>
                        {/* PORCENTAJE*/}


                        {
                            (validPorcentejeSpecial === "https://labcen.helen-sw.com" ||
                                validPorcentejeSpecial === "https://hsjs.helen-sw.com" ||
                                validPorcentejeSpecial === "https://almass.helen-sw.com" ||
                                validPorcentejeSpecial === "https://insan.helen-sw.com" ||
                                validPorcentejeSpecial === "https://phersu.helen-sw.com" ||
                                validPorcentejeSpecial === "https://arcangeles.helen-sw.com"
                            )
                            &&
                            <div className={`discount-card ${percentage ? "active" : ""}`}>
                                <label>Porcentaje a asignar</label>

                                <div className="discount-row">
                                    <Input
                                        name="percentage"
                                        value={percentage}
                                        onChange={(e) => {
                                            handleInputChangeSpecialDiscount(e);
                                            setIsPercentageApplied(false);
                                        }}
                                        className="discount-input"
                                        disabled={isAnyApplied && !isPercentageApplied}
                                    />

                                    <Button
                                        size="sm"
                                        className={`btn-warning ${isPercentageApplied ? "applied" : ""}`}
                                        onClick={handleApplyPercentage}
                                        disabled={isPercentageApplied || (isAnyApplied && !isPercentageApplied)}
                                    >
                                        {isPercentageApplied ? "Aplicado" : "Aplicar"}
                                    </Button>
                                </div>
                            </div>
                        }

                        {
                            (validPorcentejeSpecial === "https://phersu.helen-sw.com" && id_branch === "9")
                            &&
                            <div className={`discount-card ${new_price ? "active" : ""}`}>
                                <label>Monto final de la orden</label>

                                <div className="discount-row">
                                    <Input

                                        name="new_price"
                                        value={new_price}
                                        onChange={handleInputChangeSpecialDiscount}
                                        style={{ textTransform: "uppercase" }}
                                        className="discount-input"
                                        disabled={isAnyApplied && !isPercentageApplied}
                                    />

                                    <Button
                                        size="sm"
                                        className={`btn-warning ${isPercentageApplied ? "applied" : ""}`}
                                        onClick={validatePriceWorkOrder}
                                        disabled={isPercentageApplied || (isAnyApplied && !isPercentageApplied)}
                                    >
                                        {isPercentageApplied ? "Aplicado" : "Aplicar"}
                                    </Button>
                                </div>
                            </div>
                        }




                        {/* PRE-CARGADO */}
                        <div className={`discount-card ${(validPorcentejeSpecial === "https://pyrsa.helen-sw.com" ||
                            validPorcentejeSpecial === "https://cedimi.helen-sw.com" ||
                            validPorcentejeSpecial === "https://demolis-lis.helen-sw.com")
                            ? ""
                            : "d-none"
                            } ${id_preloaded_discount ? "active" : ""}`}>

                            <label>Catálogo de descuentos</label>

                            <div className="discount-row">
                                <div style={{ flex: 1 }}>
                                    <Select
                                        classNamePrefix="select"
                                        name="id_preloaded_discount"
                                        value={id_preloaded_discount}
                                        options={dataPreloaded}
                                        onChange={(e) => {
                                            handleSelectValuesPreloadedDiscounts(e, "id_preloaded_discount");
                                            setIsPreloadedApplied(false);
                                        }}
                                        placeholder="Selecciona un descuento"
                                        isClearable
                                        menuPlacement="top"
                                        isDisabled={isAnyApplied && !isPreloadedApplied}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                borderRadius: "14px",
                                                minHeight: "36px",
                                                fontSize: "10px",
                                                background: state.isFocused ? "#eff6ff" : "#fff",
                                                borderColor: state.isFocused ? "#1e3a8a" : "#d1d5db",
                                                boxShadow: state.isFocused
                                                    ? "0 0 0 2px rgba(30,58,138,0.25)"
                                                    : "none",
                                                transition: "all .2s ease",
                                                paddingLeft: "4px"
                                            }),

                                            valueContainer: (provided) => ({
                                                ...provided,
                                                padding: "2px 8px"
                                            }),

                                            input: (provided) => ({
                                                ...provided,
                                                margin: "0px",
                                                padding: "0px"
                                            }),

                                            indicatorSeparator: () => ({
                                                display: "none"
                                            }),

                                            dropdownIndicator: (provided, state) => ({
                                                ...provided,
                                                padding: "4px",
                                                color: state.isFocused ? "#1e3a8a" : "#64748b"
                                            }),

                                            menu: (provided) => ({
                                                ...provided,
                                                borderRadius: "12px",
                                                overflow: "hidden",
                                                marginTop: "6px"
                                            }),

                                            menuList: (provided) => ({
                                                ...provided,
                                                padding: "4px"
                                            }),

                                            option: (provided, state) => ({
                                                ...provided,
                                                fontSize: "12px",
                                                padding: "8px 10px",
                                                borderRadius: "8px",
                                                backgroundColor: state.isSelected
                                                    ? "#1e3a8a"
                                                    : state.isFocused
                                                        ? "#eff6ff"
                                                        : "#fff",
                                                color: state.isSelected ? "#fff" : "#1e293b",
                                                cursor: "pointer"
                                            }),

                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                                        }}

                                        formatOptionLabel={(option, { context }) => {
                                            return (
                                                <div style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px"
                                                }}>
                                                    <i className="fa fa-tag" style={{ fontSize: "11px", color: "#f97316" }}></i>
                                                    <span>{option.label}</span>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>

                                <Button
                                    size="sm"
                                    className={`btn-warning ${isPreloadedApplied ? "applied" : ""}`}
                                    onClick={handleApplyPreloaded}
                                    disabled={isPreloadedApplied || (isAnyApplied && !isPreloadedApplied)}
                                >
                                    {isPreloadedApplied ? "Aplicado" : "Aplicar"}
                                </Button>
                            </div>
                        </div>

                    </div>
                </Col>
            }
        </Dialog >

    )
}

